// PRODUCTION — live-updates skeleton shown during the first preview fetch.
import React, { memo } from 'react'
import tw from 'twin.macro'

const LoadingStateComponent = () => {
  return (
    <div css={tw`flex flex-col gap-2.5`}>
      {[0, 1, 2].map((index) => {
        return (
          <div
            key={index}
            css={tw`h-24 w-full animate-pulse rounded-[10px] border border-shades-200 bg-shades-100 border-solid`}
          />
        )
      })}
    </div>
  )
}

export const LoadingState = memo(LoadingStateComponent)
